module.exports = __webpack_public_path__ + "img/Skirt-Back-B6-Da-Gc-Ha.863dff03.png";